import { m } from 'framer-motion';
// @mui
import { alpha, useTheme, styled } from '@mui/material/styles';
import { Box, Card, Container, Typography } from '@mui/material';
// components
import { MotionViewport, varFade } from '../../components/animate';

// ----------------------------------------------------------------------

const CARDS = [
  {
    icon: '/static/home/bakery.webp',
    backdrop: '#865D3B',
    title: 'Lieblingsbäcker auswählen',
    description:
      'Suche Deine Lieblingsbäckerei ganz einfach nach PLZ in der App.',
  },
  {
    icon: '/static/home/order.webp',
    backdrop: '#000000',
    title: 'Bestellung aufgeben',
    description:
      'Dein Wunschprodukt ist immer verfügbar und du hast alle Produkte im Überblick.',
  },
  {
    icon: '/static/home/pickup.webp',
    backdrop: '#965735',
    title: 'Abholen',
    description:
      'Hole deine Ware ohne langes Warten und Bezahlen beim Bäcker ab.',
  },
];

const shadowIcon = (color: string) => `drop-shadow(2px 2px 2px ${alpha(color, 0.48)})`;

const RootStyle = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.neutral,
  paddingTop: theme.spacing(15),
  [theme.breakpoints.up('md')]: {
    paddingBottom: theme.spacing(15),
  },
}));

const CardStyle = styled(Card)(({ theme }) => ({
  maxWidth: 380,
  minHeight: 300,
  margin: 'auto',
  textAlign: 'center',
  padding: theme.spacing(10, 5, 0),
  '&.cardLeft': {
    [theme.breakpoints.up('md')]: { marginTop: -80 },
  },
  '&.cardCenter': {
    [theme.breakpoints.up('md')]: { marginTop: -40 },
  },
  backgroundColor: 'transparent',
  boxShadow: 'none'
}));

const CardIconStyle = styled('img')(({ theme }) => ({
  height: 50,
  margin: 'auto',
  marginBottom: theme.spacing(3),
}));

// ----------------------------------------------------------------------

export default function HomeMinimal() {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  return (
    <RootStyle>
      <Container component={MotionViewport}>
        <Box
          sx={{
            textAlign: 'center',
            mb: 10,
          }}
        >
          <m.div variants={varFade().inUp}>
            <Typography component="div" variant="overline" sx={{ mb: 2, color: 'text.disabled' }}>
              OrderBrot
            </Typography>
          </m.div>
          <m.div variants={varFade().inDown}>
            <Typography variant="h2">Wie funktioniert's?</Typography>
          </m.div>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gap: { xs: 5, lg: 10 },
            gridTemplateColumns: { xs: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)' },
          }}
        >
          {CARDS.map((card, index) => (
            <m.div variants={varFade().inUp} key={card.title}>
              <CardStyle
                className={(index === 0 && 'cardLeft') || (index === 1 && 'cardCenter') || ''}
              >
                <CardIconStyle
                  src={card.icon}
                  alt={card.title}
                  sx={{
                    ...{filter: (theme) => shadowIcon(card.backdrop)},
                  }}
                />
                <Typography variant="h5" paragraph>
                  {card.title}
                </Typography>
                <Typography sx={{ color: isLight ? 'text.secondary' : 'common.white' }}>
                  {card.description}
                </Typography>
              </CardStyle>
            </m.div>
          ))}
        </Box>
      </Container>
    </RootStyle>
  );
}
